import { Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'

import { Observable } from 'rxjs'

import { environment } from '../../../environments/environment'

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add x-orderfield-tenant to every request to be able to test a specific tenant locally
    if (!environment.production) {
      // Only add if Authorization header is not available. If this header is available, tenant is already specified in JWT
      if (!request.headers.has('authorization') || request.headers.get('authorization').toLowerCase() === 'jwt empty') {
        // Don't send header to auth/login or auth/token endpoints
        if (request.url.indexOf('auth/login') < 0 && request.url.indexOf('auth/token') < 0) {
          request = request.clone({
            setHeaders: {
              'x-orderfield-tenant': 'giant'
            }
          })
        }
      }
    }

    return next.handle(request)
  }
}
